import { SelfStudyRecordPage } from "@/pages/teacher/SelfStudyRecordPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/self-study-record/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <SelfStudyRecordPage />;
}
